<ag-grid-angular style="width: 100%; height: 100%" class="ag-theme-balham" [defaultColDef]="defaultColDefs"
    [rowData]="rowData" [columnDefs]="columnDefs" [frameworkComponents]="frameworkComponents"
    (firstDataRendered)="onFirstDataRendered($event)"
    (gridReady)="onGridReady($event)" rowModelType="clientSide" [paginationPageSize]="paginationSize" [cacheBlockSize]="cacheSize"
    rowSelection="multiple" [pagination]="isPage" [localeTextFunc]="gridLangugage.gridOptions.localeTextFunc" (sortChanged)="sorted($event)"></ag-grid-angular>

    <select (change)="onLimitChange($event)" #limitOpt>
    <option value="20">20</option>
    <option value="50" selected="selected">50</option>
    <option value="100">100</option>
    <option value="all">{{'All' | translate}}</option>
</select>
